import React from 'react';
import { OptionsProps } from '../../../../../types/types.ds';

const OptionCard = (props: { option: OptionsProps }) => {
    return <div>{props.option.name}</div>;
};

export default OptionCard;
